import { ChangeDetectionStrategy, Component, ElementRef, input, OnInit, output, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-navigation-menu-header',
  templateUrl: './navigation-menu-header.component.html',
  styleUrls: ['./navigation-menu-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class NavigationMenuHeaderComponent implements OnInit {
  readonly title = input.required<string>();
  readonly hasBackArrow = input(false);

  readonly closeEvent = output<void>();
  readonly backEvent = output<void>();

  closeButton = viewChild<ElementRef<HTMLElement>>('closeButton');

  ngOnInit(): void {
    this.closeButton()?.nativeElement.focus();
  }
}
